interface IProps {
    children: React.ReactNode;
}

export const Main = (props: IProps) => {
    return <main className={"flex-grow-1 d-flex flex-column"}>{props.children}</main>;
};
